import React, { useState } from 'react';
import { RefreshCw, Check, X } from 'lucide-react';

const RefreshButton = ({ onRefresh, className = '' }) => {
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [status, setStatus] = useState('idle'); // 'idle', 'loading', 'success', 'error'

    const handleClick = async () => {
        if (isRefreshing) return;

        setIsRefreshing(true);
        setStatus('loading');

        try {
            await onRefresh();

            // Afficher le succès
            setStatus('success');

            // Retour à l'état normal après 2 secondes
            setTimeout(() => {
                setStatus('idle');
                setIsRefreshing(false);
            }, 2000);
        } catch (error) {
            console.error('Erreur lors du refresh:', error);

            // Afficher l'erreur
            setStatus('error');

            // Retour à l'état normal après 2 secondes
            setTimeout(() => {
                setStatus('idle');
                setIsRefreshing(false);
            }, 2000);
        }
    };

    // Icône en fonction du statut
    const getIcon = () => {
        switch (status) {
            case 'success':
                return <Check className="w-4 h-4 sm:w-5 sm:h-5 text-white" />;
            case 'error':
                return <X className="w-4 h-4 sm:w-5 sm:h-5 text-white" />;
            default:
                return (
                    <RefreshCw
                        className={`w-4 h-4 sm:w-5 sm:h-5 text-white transition-transform duration-500 ${
                            isRefreshing ? 'animate-spin' : ''
                        }`}
                    />
                );
        }
    };

    // Couleur du bouton en fonction du statut
    const getButtonClass = () => {
        switch (status) {
            case 'success':
                return 'bg-green-600/80 hover:bg-green-600 border-green-400/50';
            case 'error':
                return 'bg-red-600/80 hover:bg-red-600 border-red-400/50';
            default:
                return 'bg-white/10 hover:bg-white/20 border-white/20 hover:border-white/30';
        }
    };

    // Titre du bouton en fonction du statut
    const getTitle = () => {
        switch (status) {
            case 'success':
                return 'Données actualisées';
            case 'error':
                return 'Erreur lors de l\'actualisation';
            case 'loading':
                return 'Actualisation en cours...';
            default:
                return 'Actualiser les données';
        }
    };

    return (
        <button
            onClick={handleClick}
            disabled={isRefreshing}
            className={`p-2 sm:p-3 rounded-full border transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed ${getButtonClass()} ${className}`}
            title={getTitle()}
        >
            {getIcon()}
        </button>
    );
};

export default RefreshButton;